/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const CorrectAnswerIcon = /*#__PURE__*/ createSvgIcon(
  'CorrectAnswerIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.5 8h4v4h-4V8zm1 1v2h2V9h-2zM17 10.5H8v-1h9v1zM1.5 14.5h4v4h-4v-4zm1 1v2h2v-2h-2zM17 16.5H8v-1h9v1zM7.354 1.354L3 5.707.646 3.354l.708-.708L3 4.293 6.646.646l.708.708zM17 4.5H8v-1h9v1z"
            fill="currentColor"
          />
        </>
      ),
    },
    rtl: {
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.5 8h4v4h-4V8zm1 1v2h2V9h-2zM3 9.5h8v1H3v-1zM13.5 14.5h4v4h-4v-4zm1 1v2h2v-2h-2zM3 15.5h8v1H3v-1zM19.354 1.354L15 5.707l-2.354-2.353.708-.708L15 4.293 18.646.646l.708.708zM3 3.5h8v1H3v-1z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default CorrectAnswerIcon;
